(function($, undefined) {
	"use strict";
	
	let formValidator;

	function init() {
		$('.wizard_step5 .wizard__questions').on('submit', onFormSubmit);
		formValidator = Fw.component.models().form;
	}

	function onFormSubmit(e) {
		let form = $('.wizard_step5 .wizard__questions');
		let list = $('.location-overview-items-list', form);
		let overviewsListItems = $('.location-overview-item', list);

		e.preventDefault();

		formValidator.validateForm(list);
		if (!list.hasClass('has-error')) {
			let overviewsArray = [];
			overviewsListItems.each((i, el) => {
				overviewsArray.push({
					"title": $('[name=title]', el).val(),
					"description": $('[name=description]', el).val()
				});
			});

			$('[name="field14"]').val(JSON.stringify(overviewsArray));
			form.get(0).submit();
		}

	}
	
	$(init);
	
})(jQuery);